import axios from '@/libs/api.request'
export const getInformation = ({ token, page, keyword }) => {
    const data = {
        token,
        page,
        keyword
    }
    return axios.request({
        url: '/shop/tools/getInformation',
        data,
        method: 'post'
    })
}
export const getDocument = ({ token, page, keyword,fstCate,sndCate,thdCate }) => {
    const data = {
        token, page, keyword, fstCate, sndCate, thdCate
    }
    return axios.request({
        url: '/shop/tools/getDocument',
        data,
        method: 'post'
    })
}
export const uploadDocument = ({ token,name,file,fstCate,sndCate,thdCate }) => {
    const data = {
        token,
        name,
        file,
        fstCate,
        sndCate,
        thdCate
    }
    var ret = axios.request({
        url: '/shop/tools/uploadDocument',
        data,
        method: 'post'
    })
    return ret;
}
// 设置数据开关
export const getTimeLater = async (that, data) => {
    var res = await axios.request({
        url: '/shop/tools/getTimeLater',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}